import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import WWCStatus from '../../../containers/forms/dashboard/WWCStatus/WWCStatus'

export default class WWCStatusModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
  }

  render() {
    const { modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title='WWC status'
        titleKey='moduleTitle.wwc_status'
        large
      >
        <MaterialModal.Content>
          <WWCStatus {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
